module.exports = __webpack_public_path__ + "static/media/cloud-services.c32bdfab.svg";